import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Element } from 'react-scroll';
import AccordionTabGroup from './AccordionTabGroup';
import InnerWrapper from '../../../global/InnerWrapper';
import Heading from './Heading';

import { sectionType } from '../utils';
import { handleSubCategories } from '../Literature/utils';

const Section = styled.div`
  display: ${p => (p.active ? 'block' : 'none')};
  overflow: hidden;
  padding: ${p => (p.hasPadding ? 0 : 20)}px 0;
`;

const SectionsWrapper = styled(InnerWrapper)`
  border-bottom: 1px solid ${p => p.theme.color.borderPrimary};
  margin-bottom: 40px;
  margin-top: 40px;
`;

const CustomContentWrapper = styled.div`
  margin-bottom: 40px;
`;

class Accordion extends React.Component {
  static propTypes = {
    AltHeading: PropTypes.object,
    AltIcon: PropTypes.object,
    className: PropTypes.string,
    sections: PropTypes.arrayOf(sectionType),
    allSubCategories: PropTypes.arrayOf(PropTypes.object)
  };

  state = {
    activeIds: []
  };

  toggleId = id => {
    this.setState(state => {
      if (!state.activeIds.includes(id)) {
        return { activeIds: state.activeIds.concat(id) };
      }
      return { activeIds: state.activeIds.filter(x => x !== id) };
    });
  };

  render() {
    const { AltHeading, AltIcon, className, sections, allSubCategories } =
      this.props;
    const { activeIds } = this.state;
    const firstSection = sections && sections[0];

    const Header = AltHeading || Heading;

    return (
      <React.Fragment>
        {firstSection && firstSection.id === 'custom' && (
          <CustomContentWrapper>
            <firstSection.view {...firstSection.data} />
          </CustomContentWrapper>
        )}
        <SectionsWrapper className={className}>
          {sections.map(({ data, subCategories, id, label, view: View }) => {
            const active = activeIds.includes(id);
            // Handle sub categories for literature sections
            const hasSubCategories = subCategories && subCategories.length > 0;

            return id === 'custom' ? null : (
              <React.Fragment key={id}>
                <Element name={id} />
                <Header active={active} onClick={this.toggleId} id={id}>
                  {label}
                  {Boolean(AltIcon) && <AltIcon active={active} />}
                </Header>
                <Section active={active} hasPadding={Boolean(AltHeading)}>
                  <View {...data} />
                  {hasSubCategories && (
                    <AccordionTabGroup
                      sections={handleSubCategories(
                        subCategories,
                        allSubCategories
                      )}
                    />
                  )}
                </Section>
              </React.Fragment>
            );
          })}
        </SectionsWrapper>
      </React.Fragment>
    );
  }
}

export default Accordion;
